module.exports = __webpack_public_path__ + "static/media/16UNODC21.1ebdb04d.jpg";